<template>

    <div v-if="loading" class="loading-box">
        <b-spinner></b-spinner>
    </div>
    <div v-else>
        <div v-if="user">
            <div class="row">
                <div class="col-lg-6 mb-20">
                    <router-link to="/account/card" class="d-block h-100">
                        <div class="box-shadow d-flex flex-column justify-content-between h-100">
                            <div class="title-4 text-uppercase color-primary mb-36">Карта клиента</div>

                            <div v-if="(user.card.type == 'Физическое лицо' && (user.card.series_number_passport == null || user.card.series_number_passport == '-')) || (user.card.type == 'Юридическое лицо' && (user.card.full_name == null || user.card.full_name == '-'))">
                                <div class="h5 color-text-grey mb-36">Вы ещё не заполнили карту клиента</div>
                                <span class="h5 link-catalog">Создать карту</span>
                            </div>


                            <div v-else>
                                <div class="h5 color-text-grey mb-0">{{user.card.fio}}</div>
                                <div class="h5 color-text-grey mb-36">{{user.card.phone}}</div>
                                <div class="h5 link-catalog">Проверить данные</div>
                            </div>

                        </div>
                    </router-link>
                </div>
<!--                <div class="col-lg-6 mb-20">-->
<!--                    <div to="/account/discount" class="d-block h-100">-->
<!--                        <div class="box-shadow d-flex flex-column justify-content-between h-100">-->
<!--                            <router-link to="/account/discount">-->
<!--                                <div class="title-4 text-uppercase color-primary mb-36">Новая дисконтная программа</div>-->
<!--                            </router-link>-->

<!--                            <div class="h5 color-text-grey mb-36" v-if="(user.card.type == 'Физическое лицо' && (user.card.series_number_passport == null || user.card.series_number_passport == '-')) || (user.card.type == 'Юридическое лицо' && (user.card.full_name == null || user.card.full_name == '-'))">Вы ещё не заполнили карту клиента, для того, чтобы воспользоваться дисконтной программой.</div>-->
<!--                            <div v-if="(user.card.series_number_passport && user.card.series_number_passport != '-') || (user.card.full_name && user.card.full_name != '-')" class="mb-36">-->
<!--                                <div class="h5 mb-0 color-text-grey nowrap">Ваша скидка:-->
<!--                                    <span class="color-text-red" v-if="user.discount_program.discount_program !== 0"> {{user.discount_program.discount_program}}%</span>-->
<!--                                    <span v-else> 0%</span>-->
<!--                                </div>-->
<!--                                <div class="h5 mb-0 color-text-grey nowrap">Накопленные баллы:-->
<!--                                    <span class="color-text-red" v-if="user.discount_program.bonuses !== 0 && !user.userData.old_discount || user.discount_program.bonuses !== 0 && user.userData.start_bonuses !== 0"> {{user.discount_program.bonuses}}</span>-->
<!--                                    <span v-else> 0</span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--&lt;!&ndash;                            <div v-else>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="h5 mb-36 color-text-grey nowrap">Всего баллов:&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span class="color-text-red">{{ user.discount_program.bonuses }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                            <router-link to="/account/discount">-->
<!--                                <div class="h5 link-catalog">Подробнее о дисконтной программе</div>-->
<!--                            </router-link>-->
<!--                            <div v-if="user.oldDiscountSystem == 1" @click="oldDiscountDialog = true" class="h5 link-catalog">Вернуться к старой программе</div>-->
<!--                            <div v-else-if="user.oldDiscountSystem == 2" class="h5 link-catalog">Запрос отправлен </div>-->
<!--                            <div v-else class="h5 link-catalog">Старая система скидок подключена </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="col-lg-6 mb-20">-->
<!--                    <router-link to="/account/ref_link" class="d-block h-100">-->
<!--                        <div class="box-shadow d-flex flex-column justify-content-between h-100">-->
<!--                            <div class="title-4 text-uppercase color-primary mb-36">Реферальная ссылка</div>-->

<!--                            <div class="h5 color-text-grey mb-36">Количество Рефералов: <span class="color-text-red">{{count_children}}</span></div>-->
<!--                            <div class="h5 color-text-grey mb-36">Количество полученных баллов: <span class="color-text-red">{{children_bonuses}}</span></div>-->
<!--                            <span class="h5 link-catalog">Создать код или ссылку</span>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                </div>-->

                <div class="col-12 d-none d-lg-block">
                    <account-new></account-new>
                </div>



                <b-modal v-if="user.oldDiscountSystem == 1" ref="modalFeedback" id="modal-feedback" v-model="oldDiscountDialog" title="" centered hide-footer hide-header>
                    <div class="modalFeedback">
                        <div class="close" @click="oldDiscountDialog = false"><img src="/svg/close.svg" alt=""></div>

                        <h3 class="font-700 mb-12">Вернуться к старой программе</h3>
                        <p class="mb-24">
                            Подтверждая возврат к старой скидочной системе, за вами фиксируется скидка, которая была у вас на 31.12.2021.
                            Внимание! Вы потеряете возможность накапливать скидки и бонусные баллы.
                        </p>

                        <div class="checkbox mb-28">
                            <input id="old_discount_system" value="1" type="checkbox"
                                   v-model="oldDiscountCheckbox">
                            <label for="old_discount_system">Я согласен перейти на старую систему скидок</label>
                        </div>

                        <button class="button btn-small btn-v2" v-if="showBtn" @click="sendData()">Подтвердить</button>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                oldDiscountDialog: false,
                oldDiscountCheckbox: 0,
                showBtn: false,
                loading: true,
                children_bonuses: 0,
                count_children: 0,
            }
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            },
        },

        mounted() {
            this.$store.dispatch('fetchUser');

            this.init();

            setTimeout(() => {
                this.loading = false;
            }, 1500)

        },

        methods: {
            init() {
                let url = '/api/get-ref-link-info';
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem('token')
                    }
                };

                axios.post(url, {}, options)
                    .then(response => {
                        if (response.status == 200) {
                            this.count_children = response.data.count_children;
                            this.children_bonuses = response.data.children_bonuses;
                        }
                    })
            },

            sendData(){
                let url = '/api/get-old-discount';
                const options = {
                    headers: {Authorization: "Bearer " + localStorage.getItem('token')},
                };
                axios.post(url, {}, options)
                    .then(response => {
                        if(response.status == 200) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Запрос отправлен.',
                                html: `Менеджеры в ближайшее время рассмотрят ваш запрос.`,
                            }).then(() => {
                                this.user.oldDiscountSystem = 2;
                            })
                        }
                    })
            }
        },
        watch: {
            oldDiscountCheckbox(val){
                if(val){
                    this.showBtn = true
                }else{
                    this.showBtn = false
                }
            }
        }

    }
</script>
